import { BROADCAST_GET_SOURCES } from '@shoflo/studio-redux/actions/types';
import { CAMERA_PRESENTER, UNASSIGNED } from '@studio/constants/Sources';

function attendeeRoster(state = {}, action) {
  if (action.type === `${BROADCAST_GET_SOURCES}_SUCCESS`) {
    const { items: sources } = action.payload;

    const attendeeRoster = {};
    sources.forEach(source => {
      if (source.type === CAMERA_PRESENTER && source.value !== UNASSIGNED) {
        const {
          value: attendeeId,
          title: name,
          presenterPhoto = '',
          role = ''
        } = source;
        attendeeRoster[attendeeId] = { name, presenterPhoto, role };
      }
    });
    return { ...attendeeRoster };
  }

  return state;
}

export default attendeeRoster;
